import { render, staticRenderFns } from "./ParticipationPanel.vue?vue&type=template&id=53adfba2"
import script from "./ParticipationPanel.vue?vue&type=script&lang=js"
export * from "./ParticipationPanel.vue?vue&type=script&lang=js"
import style0 from "./ParticipationPanel.vue?vue&type=style&index=0&id=53adfba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports